// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","448":"component---src-templates-design-style-js","465":"component---src-pages-preview-js"}[chunkId] || chunkId) + "-" + {"125":"461995b6fbe6cf7f00f4","448":"434057ed078fbc6247ef","452":"1df59f3f81180fbb5f22","465":"a88c2db7b8bfa705d726","896":"597d3ad838545deecf93"}[chunkId] + ".js";
};